import { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';

/**
 * Boton flotante que aparece tras scrollear >70% de la pagina y
 * regresa al top con scroll suave. Posicionado por encima del TOC mobile.
 */
export default function BackToTop({ language = 'es' }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const total = document.documentElement.scrollHeight - window.innerHeight;
      if (total <= 0) {
        setVisible(false);
        return;
      }
      const ratio = window.scrollY / total;
      setVisible(ratio > 0.7);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed right-4 lg:right-6 bottom-20 lg:bottom-6 z-40
                 flex items-center gap-2 px-4 py-2.5 rounded-full
                 bg-emerald-500 hover:bg-emerald-400 text-slate-900 font-semibold text-xs
                 shadow-xl shadow-emerald-500/30
                 animate-toc-fade-in transition-colors"
      data-testid="back-to-top-btn"
      aria-label={language === 'es' ? 'Volver arriba' : 'Back to top'}
    >
      <ArrowUp className="w-4 h-4" />
      <span>{language === 'es' ? 'Volver arriba' : 'Back to top'}</span>
    </button>
  );
}
